export default {
  computed: {
    inputError () {
      return this.getError(this.errors.organization, this.inputName)
    },

    hasInputErrors () {
      return this.hasError(this.errors.organization, this.inputName)
    }
  }
}
